<template>
  <div ref="queryForm">
    <el-form
      ref="forms"
      :class="More ? 'glo_form hasMoreParam' : 'glo_form'"
      label-position="left"
      :style="{
        marginTop: marginTop ? '10px' : '0',
      }"
    >
      <span
        style="display: flex; align-items: center"
        v-for="(item, index) in F_config.filter(
          (item) => item.isShow && !item.fieldIsGroup
        )"
        :key="index"
      >
        <span>
          <el-form-item
            :class="calcClass(item)"
            :label="item.fieldGroupShow || item.conditonKeyShow"
          >
            <query-condition-item
              :F_config="F_config"
              :item="item"
              :index="index"
            >
              <template
                v-for="(child, pos) in F_config.filter(
                  (kk) =>
                    kk.isShow &&
                    kk.fieldIsGroup &&
                    kk.fieldGroupKey === item.conditonKey
                )"
              >
                <query-condition-item
                  :F_config="F_config"
                  :item="child"
                  :index="pos"
                  :key="item.conditonVal + 'child-' + pos"
                ></query-condition-item>
              </template>
            </query-condition-item>
          </el-form-item>
        </span>
        <slot :name="item.conditonKey"></slot>
      </span>
      <slot></slot>
    </el-form>
  </div>
</template>
<script>
import queryConditionItem from "./queryConditionItem.vue";
import multitime from "@/components/multiTime.vue";
export default {
  components: { queryConditionItem, multitime },
  props: {
    formConfig: {
      type: Array,
    },
    formData: {
      type: Object,
    },
    More: {
      type: Boolean,
    },
    marginTop: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["changeCallback", "EnterClick"],
  data() {
    return {
      F_config: this.formConfig,
      F_Data: this.formData,
    };
  },
  watch: {
    formConfig: {
      handler(newValue, oldValue) {
        this.F_config = newValue;
      },
      deep: true, // 默认值是 false，代表是否深度监听
    },
  },
  methods: {
    calcClass(item) {
      if (item.textBoxType === "date" || item.textBoxType === "datetime") {
        return "queryItemsTimes";
      }
      if (item.textBoxType === "dept_tree") {
        return "queryItems";
      }
      let clazz = "queryItems";
      if (item.textBoxType === "month") {
        clazz += " month";
      }
      if (item.fieldGroupShow) {
        clazz += " group-fields";
      }
      return clazz;
    },
    // 选择结算对象
    changeObjVal(val, item, index) {
      if (item.conditonKey == "objectStatusConfDictId") {
        let list = item.selectOptions || [];
        list.forEach((element) => {
          if (element.id == val) {
            this.F_config[index].key = element.key;
          }
        });
        if (!val) {
          this.F_config[index + 1].conditonVal = "";
        }
      }
    },
    // 获取结算对象/类型下拉列表
    async getList(e, item, index) {
      if (e) {
        let arrs = [
          {
            conditonKey: item.dropdownShowField,
            conditonVal: "",
          },
        ];
        if (item.conditonKey == "objectName") {
          // item.conditonKey == 'objectName' && !F_config[index-1].conditonVal
          arrs.push({
            conditonKey: "key",
            conditonVal: this.F_config[index - 1].key,
          });
        }
        await this.$API
          .runListReport({
            conditionReqs: arrs,
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 9999,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            this.F_config[index].selectOptions = datas;
          });
      }
    },

    // 多条件输入框，中间都隔开
    changeInputMore(item) {
      // if(!item.conditonVal_1){
      //   item.conditonVal = []
      //   return
      // }
      // item.conditonVal = item.conditonVal_1.split(',')
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e, index) {
      // this.F_config[index].startTime_a = `${s} 00:00:00` || "";
      // this.F_config[index].endTime_a = `${e} 23:59:59` || "";
      this.F_config[index].startTime_a = s || "";
      this.F_config[index].endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e, index) {
      this.F_config[index].timeType = type || "";
      // this.F_config[index].startTime_a = `${s} 00:00:00` || "";
      // this.F_config[index].endTime_a = `${e} 23:59:59` || "";
      this.F_config[index].startTime_a = s || "";
      this.F_config[index].endTime_a = e || "";
    },
    async focusMethod(item, index) {
      if (!item.selectOptions || item.selectOptions.length == 0) {
        const conditions = [
          {
            conditonKey: item.dropdownShowField,
            conditonVal: "",
          },
        ];
        if (item.dropdownDefaultConditionField) {
          conditions.push({
            conditonKey: item.dropdownDefaultConditionField,
            conditonVal: item.dropdownDefaultSelectVal,
          });
        }
        await this.$API
          .runListReport({
            conditionReqs: conditions,
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 9999,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            item.selectOptions = datas;
          });
      }
    },
    // 远程搜索
    async remoteMethod(e, item, index) {
      await this.$API
        .runListReport({
          conditionReqs: [
            {
              conditonKey: item.dropdownShowField,
              conditonVal: e,
            },
          ],
          number: item.dropdownApiNumber,
          pageStart: 1,
          pageTotal: 9999,
        })
        .then((res) => {
          let datas = res.data.result.datas.data || [];
          item.selectOptions = datas;
        });
      this.$emit("changeCallback", e, name);
    },
    // 远程搜索(结算对象/类型)
    async remoteMethodOBJ(e, item, index) {
      if (item.conditonKey == "objectName") {
        let arrs = [
          {
            conditonKey: item.dropdownShowField,
            conditonVal: e,
          },
        ];
        if (item.conditonKey == "objectName") {
          arrs.push({
            conditonKey: "key",
            conditonVal: this.F_config[index - 1].key,
          });
        }
        await this.$API
          .runListReport({
            conditionReqs: arrs,
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 9999,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            item.selectOptions = datas;
          });
      }
    },
    // 滚动条加载更多
    loadmore(e) {
      this.$emit("changeCallback", "", e);
    },
    enterClick() {
      this.$emit("EnterClick");
    },
    after() {
      this.$emit("after");
    },
  },
};
</script>
<style lang="less">
.months {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }

  // .el-input__prefix {
  //   right: 5px !important;
  // }
}
</style>
<style scoped lang="less">
.group-fields {
  width: auto;
  /deep/ .el-input {
    width: 240px;
  }
  /deep/ .el-select {
    width: 120px;
  }
}
</style>
